module.exports = __webpack_public_path__ + "img/downts.9980d41d.png";